// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3u6Xc{display:inline-block;background:#dcdddd;border-radius:.25rem;color:#231815;padding:.25rem .75rem;font-size:14px;font-size:.875rem;font-weight:400;line-height:23px;line-height:1.4375rem;font-family:var(--base-font)}@media(max-width:767px){._3u6Xc{font-size:1rem;line-height:1.625rem}}", ""]);
// Exports
exports.locals = {
	"root": "_3u6Xc"
};
module.exports = exports;
